import { t } from 'i18next';
import Style from '../styles/RTMSelectedProductsView.module.scss';
import { RTMSelectedProductsViewProps } from '../types/RTMTypes';

const RTMSelectedProductsView = (props: RTMSelectedProductsViewProps) => {
  return (
    <div className={Style.RTMSelectedProductsView}>
      <div className='RTMSelectedProductsView-container'>
        <h3 className='title'>{t('selectedproducts')}</h3>
        <div className='selected-list'>
          {props.selectedProducts.map((product, key) => (
            <div key={key} className='selected'>{`${product.name}: ${product.count}`}</div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default RTMSelectedProductsView;
